import * as React from 'react'
import {
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from '@material-ui/core'
import { jt, t } from 'ttag'

import { ReactComponent as GearIcon } from '../../assets/icons/gear.svg'
import { ReactComponent as EditIcon } from '../../assets/icons/pencil.svg'
import { ReactComponent as PrivacyIcon } from '../../assets/icons/privacy.svg'
import { ReactComponent as SyncIcon } from '../../assets/icons/sync.svg'
import { ReactComponent as DeleteIcon } from '../../assets/icons/trash.svg'
import { ReactComponent as CancelIcon } from '../../assets/v2/icons/cancel.svg'
import { ReactComponent as EmailIcon } from '../../assets/v2/icons/support.svg'
import { ReactComponent as AddIcon } from '../../assets/v3/icons/add.svg'

import { ReactComponent as CheckboxSelectedIcon } from '../../assets/v3/icons/checkbox-selected.svg'
import { ReactComponent as CheckboxIcon } from '../../assets/v3/icons/checkbox.svg'

import { ReactComponent as LockIcon } from '../../assets/v2/icons/lock.svg'
import { ReactComponent as LockFilledIcon } from '../../assets/v2/icons/lock-filled.svg'

import { ReactComponent as StarIcon } from '../../assets/v2/icons/star.svg'
import { ReactComponent as StarFilledIcon } from '../../assets/v2/icons/star-filled.svg'

import { ReactComponent as AcceptedIcon } from '../../assets/v2/icons/checked-circle-blue.svg'
import { ReactComponent as ErrorIcon } from '../../assets/v2/icons/error.svg'
import { ReactComponent as LockErrorIcon } from '../../assets/v2/icons/lock-error.svg'
import { ReactComponent as RemoveIcon } from '../../assets/v3/icons/remove.svg'

import {
  convertCmToFtIn,
  convertFtInToCm,
  DATE_FORMAT,
  getServiceProviderLabel,
  isDateOfBirthErrorVisible,
  isDateOfBirthValid,
  isNumberFieldErrorVisible,
  isTextFieldErrorVisible,
  precisionRoundMod,
} from '../../common/helpers/formHelpers'
import { isIOS, isNative } from '../../common/helpers/isNative'
import { getFullName } from '../../common/helpers/translations'
import { ROUTES } from '../../common/Routes/routePaths'
import { Button } from '../../components/Button/Button'
import { ButtonGroup } from '../../components/ButtonGroup/ButtonGroup'
import { Card } from '../../components/Card/Card'
import { Initials } from '../../components/Initials/Initials'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import {
  ChangePassword$Request,
  CompanyCountriesDto,
  CompanyId,
  DeleteUserOwnedCompany$Request,
  DivisionDto,
  DivisionId,
  Gender,
  JoinCompany$Request,
  Lang,
  LeaveCompany$Request,
  PasswordPolicy,
  Role,
  ServiceProvider,
  SetUserCountry$Request,
  SetUserDivision$Request,
  Units,
  UserCompanyDto,
  UserId,
  UserProfileDto,
} from '../../services/api.types'
import './Settings.scss'
import { currentLang, isRtl } from '../../i18nInit'
import dayjs from '../../dayjsConfig'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import YumCountrySelect from '../../components/YumCountrySelect/YumCountrySelect'
import YumTimeZoneSelect from '../../components/YumTimeZoneSelect/YumTimeZoneSelect'
import {
  isCompanyCountryRequired,
  isCompanyDivisionRequired,
  isCompanyUserCreatedTeams,
} from '../RegisterUser/RegisterUser'
import { MIN_HEIGHT_CM, MIN_WEIGHT_KG } from '../RegisterUser/components/ActivityForm'
import { CellInfo, Column, RowInfo } from 'react-table'
import { Table } from '../../components/Table/Table'
import FormLabel from '@material-ui/core/FormLabel'
import { dataSync, refreshActivityView } from '../../services/DataSync'
import { openPrivacyPolicy, openTermsOfService } from '../../common/helpers/routeHelpers'
import { scrollToTop } from '../../common/helpers/scroll'
import { Capacitor } from '@capacitor/core'
import YumSwitch from '../../components/YumSwitch/YumSwitch'
import { darkBlue, red } from '../../styles/material-ui-theme-v2'
import { YumLanguageSelection } from '../../components/YumLanguageSelection/YumLanguageSelection'
import {
  unitsCountLengthCentimeterShort,
  unitsCountLengthFootShort,
  unitsCountLengthInchShort,
  unitsCountMassKilogramShort,
  unitsCountMassPoundShort,
} from '../../common/helpers/units'
import YumSelect from '../../components/YumSelect/YumSelect'
import YumInput from '../../components/YumInput/YumInput'
import YumPhoneInput from '../../components/YumPhoneInput/YumPhoneInput'
import YumDateOfBirth from '../../components/YumDateOfBirth/YumDateOfBirth'
import { ReactComponent as DateActiveIcon } from '../../assets/v3/icons/announcements/schedule.svg'
import { ReactComponent as WeightInactiveIcon } from '../../assets/v3/icons/weight-inactive.svg'
import { ReactComponent as HeightInactiveIcon } from '../../assets/v3/icons/height-inactive.svg'
import { store } from '../../index'
import { addNotification } from '../../common/notifications/NotificationActions'
import { INotification } from '../../common/notifications/NotificationReducers'
import { getShortDateString, getShortDateWithTimeString } from '../../common/helpers/date'
import YumPasswordPolicy from '../../components/YumPasswordPolicy/YumPasswordPolicy'
import YumButtonGroup from '../../components/YumButtonGroup/YumButtonGroup'
import YumDialog from '../../components/YumDialog/YumDialog'
import YumDialogTitle from '../../components/YumDialogTitle/YumDialogTitle'
import YumDialogActions from '../../components/YumDialogActions/YumDialogActions'
import YumSubmitButton from '../../components/YumSubmitButton/YumSubmitButton'
import YumDialogContent from '../../components/YumDialogContent/YumDialogContent'
import YumCancelButton from '../../components/YumCancelButton/YumCancelButton'
import YumDialogContentText from '../../components/YumDialogContentText/YumDialogContentText'
import { push } from 'connected-react-router'
import CompaniesWrapper from './components/CompaniesWrapper'
import { hasFeatureFlag } from '../../common/helpers/featureFlags'
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage'
import { HealthConnect } from '../../services/HealthConnect'

// Type declaration for Cordova health plugin
declare global {
  interface Window {
    cordova?: {
      plugins?: {
        health?: {
          openHealthSettings: (successCallback: () => void, errorCallback: (error: any) => void) => void
        }
      }
    }
  }
}

const convert = require('convert-units')

export interface IChangePasswordPayload extends ChangePassword$Request {
  confirmPassword: string
}

export interface IStateProps {
  hasRole(role: Role): boolean
  userDto: UserProfileDto
  //activity: ActivityProgress
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  userCompanies: UserCompanyDto[]
}

export interface UpdateUserProfileState {
  country: string
  dateOfBirth: string | null
  divisionId: DivisionId
  firstName: string
  gender: Gender | null
  height: number | null
  lastName: string
  phone: string
  //newsletterSubscriber: boolean
  onlyProfileUpdate: boolean
  ssn: string
  timeZone: string
  units: Units | null
  weight: number | null
}

export interface IDispatchProps {
  syncIntegration(payload: { noMessage: boolean }): void
  endIntegration(): void
  //getUserActivity(): void
  getUserCompanyCountries(): void
  getCompanyDivisions(): void
  deleteUser(payload: { userId: UserId; companyId: CompanyId | null }): void
  changePassword(payload: IChangePasswordPayload): void
  changeUserLanguage(payload: Lang): void
  appleHealthIntegration(): void
  registerHealthConnect(): void
  updateUser(payload: UpdateUserProfileState): void
  joinCompany(payload: JoinCompany$Request): void
  joinCompanySuccess(): void
  leaveCompany(payload: LeaveCompany$Request): void
  deleteUserOwnedCompany(payload: DeleteUserOwnedCompany$Request): void
  setUserDivision(payload: SetUserDivision$Request): void
  setUserCountry(payload: SetUserCountry$Request): void
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
  togglePublicStatus(): void
  getWhoAmI(): void
  setOnboardingStatusToIntegration(): void
  setOnboardingStatusToActivityData(): void
}

type ISettingsProps = IStateProps & IDispatchProps

export interface ISettingsState {
  oldPassword: string
  newPassword: string
  confirmPassword: string
  isDeleteModalOpen: boolean
  isLeaveModalOpen: boolean
  leaveCompanyId: CompanyId | null
  leaveCompanyName: string
  isLeaveCompanyOwner: boolean
  //editServiceProvider: boolean
  joinCompany: boolean
  signUpCode: string
  editProfile: boolean
  editPassword: boolean
  hasActivityIndexData: boolean

  firstName: string
  lastName: string
  email: string
  dateOfBirth: string
  gender: Gender.MALE | Gender.FEMALE
  units: Units.METRIC | Units.IMPERIAL
  weight: string | number
  weightLbs: string | number
  height: string | number
  heightFt: string | number
  heightIn: string | number
  isProfileFormValid: boolean
  phone: string
  ssn: string
  timeZone: string
  //newsletterSubscriber: boolean

  publicChallengesJustClicked: boolean

  passwordPolicy: PasswordPolicy
  isPasswordPolicyValid: boolean
  focus: {
    newPassword: boolean
    confirmPassword: boolean
  }

  deleteInProgress: boolean
  healthConnectSyncedTypes: string[]
}

const timeZone = dayjs.tz.guess()
const isUsa = timeZone.startsWith('America/') || timeZone.startsWith('US/')

export const yuMuuvPublicCompanyId = '2d098838-2d06-ea86-3445-b9d039fbd0d3'
export const myFitnessPublicCompanyId = 'be59656c-6ccb-4aaa-9eae-92cff1becd55'
export const noBananasPublicCompanyId = '96302717-6052-454e-ad70-94da580fa7e4'
export const tallinkPublicCompanyId = '7e90c098-4670-435d-8b1e-40e01ebbe0d5'
export const cachetPublicCompanyId = '44d1ff30-4a66-4f60-a4f2-081be6ce7f82'
export const hiltonPublicCompanyId = '52a930c6-5bf0-46d0-9952-35bf8e5d3fd7'

export const isPublicChallengeCompany = (companyId: CompanyId) => {
  return [
    yuMuuvPublicCompanyId,
    myFitnessPublicCompanyId,
    noBananasPublicCompanyId,
    tallinkPublicCompanyId,
    cachetPublicCompanyId,
    hiltonPublicCompanyId,
  ].includes(companyId)
}

export class Settings extends React.PureComponent<ISettingsProps, ISettingsState> {
  defaultProfile = {
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: '',
    gender: Gender.MALE,
    units: isUsa ? Units.IMPERIAL : Units.METRIC,
    weight: '',
    height: '',
    phone: '',
    ssn: '',
    timeZone,
    //newsletterSubscriber: false,
  }
  state = {
    confirmPassword: '',
    isDeleteModalOpen: false,
    isLeaveModalOpen: false,
    leaveCompanyId: null,
    leaveCompanyName: '',
    isLeaveCompanyOwner: false,
    isProfileFormValid: true,
    newPassword: '',
    oldPassword: '',
    //editServiceProvider: false,
    joinCompany: false,
    signUpCode: '',
    editProfile: false,
    editPassword: false,
    weightLbs: '',
    heightFt: '',
    heightIn: '',
    hasActivityIndexData: false,
    publicChallengesJustClicked: false,
    passwordPolicy: PasswordPolicy.DEFAULT,
    isPasswordPolicyValid: true,
    focus: {
      newPassword: false,
      confirmPassword: false,
    },
    deleteInProgress: false,
    healthConnectSyncedTypes: [],
    ...this.defaultProfile,
  }

  componentDidMount(): void {
    const { hasRole, getUserCompanyCountries, getCompanyDivisions, userDto, getWhoAmI, joinCompanySuccess } = this.props
    const isUser = hasRole(Role.USER)

    // Reset join company loading state when settings view loads
    joinCompanySuccess()

    this.checkHealthConnectPermissions()

    if (isUser) {
      getWhoAmI()
      getUserCompanyCountries()
      getCompanyDivisions()
      const {
        email,
        dateOfBirth: userDateOfBirth,
        gender: userGender,
        units: userUnits,
        height,
        weight,
        lastName,
        firstName,
        phone,
        ssn,
        timeZone,
        //newsletterSubscriber,
      } = userDto
      const dateOfBirth = userDateOfBirth ? dayjs(userDateOfBirth).format(DATE_FORMAT) : ''
      //const dateOfBirth = userDateOfBirth ? getShortDateString(dayjs(userDateOfBirth).locale('en').valueOf()) : ''
      const gender = userGender ? userGender : Gender.MALE
      const units = userUnits ? userUnits : Units.METRIC

      this.setState({
        email,
        dateOfBirth,
        gender,
        units,
        height,
        weight,
        lastName,
        firstName,
        phone: phone || '',
        ssn: ssn || '',
        timeZone,
        //newsletterSubscriber,
        hasActivityIndexData: !!dateOfBirth,
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<ISettingsProps>, prevState: Readonly<ISettingsState>, snapshot?: any): void {
    const { userDto } = this.props
    const {
      dateOfBirth,
      gender: userGender,
      units: userUnits,
      height,
      weight,
      lastName,
      firstName,
      timeZone,
      phone,
      ssn,
    } = userDto
    const gender = userGender ? userGender : Gender.MALE
    const units = userUnits ? userUnits : Units.METRIC

    if (prevProps.userDto !== userDto) {
      const userDOB = dateOfBirth ? dayjs(dateOfBirth).format(DATE_FORMAT) : ''
      //const userDOB = dateOfBirth ? getShortDateString(dayjs(dateOfBirth).locale('en').valueOf()) : ''
      const { heightFt, heightIn } = convertCmToFtIn(this.state.height)
      const weightLbs = precisionRoundMod(convert(weight).from('kg').to('lb'), 5)
      this.setState({
        dateOfBirth: userDOB,
        gender,
        units,
        height,
        weight,
        heightFt,
        heightIn,
        weightLbs,
        lastName,
        firstName,
        phone: phone || '',
        ssn: ssn || '',
        timeZone,
        hasActivityIndexData: !!dateOfBirth,
      })
    }
  }

  isProfileFormValid() {
    const { firstName, lastName, dateOfBirth, weight, height, hasActivityIndexData, phone, ssn } = this.state
    const { userCompanies } = this.props
    const requirePhoneField = hasFeatureFlag(userCompanies, 'phoneRequired')
    const requireSsnField = hasFeatureFlag(userCompanies, 'ssnRequired')
    const showPhoneField = hasFeatureFlag(userCompanies, 'phoneField')
    const showSsnField = hasFeatureFlag(userCompanies, 'ssnField')
    const ssnLastFour = hasFeatureFlag(userCompanies, 'ssnLastFour')

    const cleanedPhone = phone ? phone.replace('+', '').trim() : ''
    const isPhoneInvalid = requirePhoneField && showPhoneField ? !cleanedPhone : false
    // When ssnLastFour is enabled, only 4 digits are valid.
    const isSsnInvalid = requireSsnField && showSsnField ? (ssnLastFour ? !/^\d{4}$/.test(ssn || '') : !ssn) : false

    if (!hasActivityIndexData) return !(!firstName || !lastName || isPhoneInvalid || isSsnInvalid)

    const isWeightInvalid = weight ? parseInt(weight, 10) < MIN_WEIGHT_KG || weight.length === MIN_WEIGHT_KG : true
    const isHeightInvalid = height ? parseInt(height, 10) < MIN_HEIGHT_CM || height.length === MIN_HEIGHT_CM : true

    return !(
      !firstName ||
      !lastName ||
      !isDateOfBirthValid(dateOfBirth) ||
      isWeightInvalid ||
      isHeightInvalid ||
      isPhoneInvalid ||
      isSsnInvalid
    )
  }

  syncData = async () => {
    const { syncIntegration, getWhoAmI, userDto } = this.props
    const { serviceProvider } = userDto
    const os = Capacitor.getPlatform()
    const appSync =
      (os === 'ios' && serviceProvider === ServiceProvider.APPLE_HEALTH) ||
      (os === 'android' &&
        (serviceProvider === ServiceProvider.GOOGLE_FIT || serviceProvider === ServiceProvider.HEALTH_CONNECT))

    if (serviceProvider === ServiceProvider.APPLE_HEALTH && os !== 'ios') {
      const notification: INotification = {
        type: 'info',
        content: t`Download YuMuuv from the App Store. Log in with your email and password.`,
      }
      await store.dispatch(addNotification(notification))
      return
    }

    // Notify back-end and show message.
    //syncIntegration({ noMessage: appSync })
    syncIntegration({ noMessage: false })

    // So people see the message.
    scrollToTop()

    // If it's Apple Health or Google Fit, initiate sync from front-end.
    if (appSync) {
      await dataSync(true, true)
    }
    // Otherwise show syncing icon for 10 seconds.
    else {
      document.body.classList.add('is-syncing')
      getWhoAmI()
      setTimeout(() => {
        //refreshActivityView()
        getWhoAmI()
        document.body.classList.remove('is-syncing')
      }, 30000)
    }
  }

  deleteUser = () => {
    const { deleteUser, userDto } = this.props
    // Prevent multiple submits.
    this.setState({ deleteInProgress: true })
    deleteUser({ userId: userDto.userId, companyId: null })
  }

  changePassword = () => {
    const { changePassword } = this.props
    const { oldPassword, newPassword, confirmPassword, isPasswordPolicyValid } = this.state

    if (oldPassword && newPassword && confirmPassword && newPassword === confirmPassword && isPasswordPolicyValid) {
      changePassword({ oldPassword, newPassword, confirmPassword })

      this.setState({ editPassword: false, oldPassword: '', newPassword: '', confirmPassword: '' })

      scrollToTop()
    }
  }

  getGridLayout = (leftColumn: JSX.Element | JSX.Element[], rightColumn: JSX.Element | JSX.Element[]) => (
    <Grid container={true} justifyContent="space-between" className="settings__grid">
      <Grid item={true}>{leftColumn}</Grid>
      <Grid item={true} className="text-right">
        {rightColumn}
      </Grid>
    </Grid>
  )

  editProfile = () => {
    const { updateUser } = this.props
    const {
      dateOfBirth: userDateOfBirth,
      firstName,
      lastName,
      gender,
      height,
      weight,
      timeZone,
      units,
      phone: phoneRaw,
      ssn,
      //newsletterSubscriber,
      hasActivityIndexData,
    } = this.state
    this.setState({ isProfileFormValid: this.isProfileFormValid() }, () => {
      if (this.state.isProfileFormValid) {
        const dateOfBirth = dayjs(userDateOfBirth, DATE_FORMAT).locale('en').format('YYYY-MM-DD')
        let phone = phoneRaw?.trim()
        if (phone === '+') phone = ''
        updateUser({
          dateOfBirth: hasActivityIndexData && dateOfBirth ? dateOfBirth : null,
          firstName,
          lastName,
          divisionId: null,
          country: '',
          timeZone,
          phone,
          ssn,
          //newsletterSubscriber,

          gender: hasActivityIndexData ? gender : null,
          height: hasActivityIndexData ? Number(height) : null,
          weight: hasActivityIndexData ? Number(weight) : null,
          units,

          onlyProfileUpdate: true,
        })
        this.setState({ editProfile: false })
      }
    })
  }

  checkHealthConnectPermissions = () => {
    const { userDto } = this.props
    if (
      !isNative() ||
      Capacitor.getPlatform() !== 'android' ||
      userDto.serviceProvider !== ServiceProvider.HEALTH_CONNECT
    )
      return

    HealthConnect.checkHealthPermissions()
      .then((result) => {
        const permissionToLabel: Record<string, string> = {
          'android.permission.health.READ_STEPS': t`Steps`,
          'android.permission.health.READ_DISTANCE': t`Distance`,
          'android.permission.health.READ_ACTIVE_CALORIES_BURNED': t`Calories`,
          'android.permission.health.READ_TOTAL_CALORIES_BURNED': t`Calories`,
          'android.permission.health.READ_HEART_RATE': t`Heart rate`,
          'android.permission.health.READ_SLEEP': t`Sleep`,
          'android.permission.health.READ_EXERCISE': t`Exercise`,
        }

        const orderedLabels: string[] = [t`Steps`, t`Distance`, t`Calories`, t`Heart rate`, t`Sleep`, t`Exercise`]

        const grantedLabels = new Set<string>()
        for (const perm of result.grantedPermissions) {
          const label = permissionToLabel[perm]
          if (label) grantedLabels.add(label)
        }

        this.setState({
          healthConnectSyncedTypes: orderedLabels.filter((label) => grantedLabels.has(label)),
        })
      })
      .catch((error) => {
        console.log('Failed to check Health Connect permissions:', error)
      })
  }

  toggleEditServiceProvider = () => {
    //this.props.setOnboardingStatusToIntegration()
    store.dispatch(push(ROUTES.CHANGE_INTEGRATION.to))
  }

  openHealthSettings = () => {
    // Check if cordova.plugins.health is available
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.health) {
      const successCallback = () => {
        console.log('Health settings opened successfully')
      }
      const errorCallback = (error: any) => {
        console.error('Error opening health settings:', error)
      }
      // Call the Cordova health plugin to open device health settings
      window.cordova.plugins.health.openHealthSettings(successCallback, errorCallback)
    } else {
      console.warn(
        'Cordova health plugin not available - this should only happen in development or if plugin is not properly installed',
      )
    }
  }

  cancelEditProfile = () => {
    const { userDto } = this.props
    const { editProfile } = this.state
    const { dateOfBirth, gender: userGender, height, weight, lastName, firstName, phone, ssn } = userDto

    const gender = userGender ? userGender : Gender.MALE

    this.setState({
      dateOfBirth: dateOfBirth ? dayjs(dateOfBirth).locale('en').format(DATE_FORMAT) : '',
      //dateOfBirth: dateOfBirth ? getShortDateString(dayjs(dateOfBirth).locale('en').valueOf()) : '',
      gender,
      height,
      weight,
      lastName,
      firstName,
      phone: phone || '',
      ssn: ssn || '',
      editProfile: !editProfile,
    })
  }

  cancelEditPassword = () => {
    const { editPassword } = this.state

    this.setState({
      editPassword: !editPassword,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    })
  }

  endIntegration = async () => {
    const { endIntegration, getWhoAmI } = this.props
    await endIntegration()
    this.toggleEditServiceProvider()
    scrollToTop()

    setTimeout(() => {
      getWhoAmI()
    }, 1000)
  }

  /*triggerAppleHealthIntegration = () => {
    this.toggleEditServiceProvider()
    scrollToTop()
    this.props.appleHealthIntegration()
  }

  triggerHealthConnectIntegration = () => {
    this.toggleEditServiceProvider()
    scrollToTop()
    this.props.registerHealthConnect()
  }*/

  getIntegrationBlock = () => {
    const { userDto, userCompanies } = this.props
    //const { editServiceProvider } = this.state
    const { lastSync, serviceProvider, dateOfBirth } = userDto

    //const lastSyncedFormatted = dayjs(lastSync).format('DD.MM.YYYY HH:mm')
    const lastSyncedFormatted = getShortDateWithTimeString(lastSync)

    /*const scope = dateOfBirth ? 'FULL' : 'LEAN'

    const syncSleep = this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.includes('sleepSync'))
    const withSleep = syncSleep ? '&s=1' : ''*/

    // No sleep sync for Google Fit.
    //const IntegrateGoogleFit = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.GOOGLE_FIT}&scope=${scope}${withSleep}`
    /*const IntegrateGoogleFit = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.GOOGLE_FIT}&scope=${scope}`
    const IntegrateFitbit = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.FITBIT}&scope=${scope}`
    const IntegrateGarmin = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.GARMIN}&scope=${scope}`
    const IntegratePolar = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.POLAR}&scope=${scope}`
    const IntegrateSuunto = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.SUUNTO}&scope=${scope}`
    const IntegrateHuawei = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.HUAWEI}&scope=${scope}`*/

    /*const integrations = [
      {
        name: 'Apple Health',
        url: isIOS ? undefined : 'https://itunes.apple.com/us/app/yumuuv/id1459357799?mt=8',
        onClick: isIOS ? this.triggerAppleHealthIntegration : undefined,
        externalLink: !isIOS,
      },
      { name: 'Health Connect', url: undefined, onClick: this.triggerHealthConnectIntegration },
      { name: 'Fitbit', url: IntegrateFitbit },
      { name: 'Garmin', url: IntegrateGarmin },
      { name: 'Google Fit', url: IntegrateGoogleFit },
      //{ name: 'HUAWEI Health Kit (BETA)', url: IntegrateHuawei },
      { name: 'Polar', url: IntegratePolar },
      { name: 'Suunto', url: IntegrateSuunto },
    ]*/

    const integration = getServiceProviderLabel(serviceProvider)

    let showGenericSyncMessage = [
      ServiceProvider.POLAR,
      ServiceProvider.FITBIT,
      ServiceProvider.SUUNTO,
      ServiceProvider.HUAWEI,
    ].includes(serviceProvider)

    if (Capacitor.getPlatform() !== 'android' && serviceProvider === ServiceProvider.GOOGLE_FIT) {
      showGenericSyncMessage = true
    }

    return (
      <section className="settings__section">
        {this.getGridLayout(
          <>{lastSync ? <p className="text-gray">{t`Last sync`}:</p> : ''}</>,
          <>{lastSync ? <p className="text-gray">{lastSyncedFormatted}</p> : ''}</>,
        )}

        {serviceProvider ? (
          <ButtonGroup>
            <Button
              className="btn-sync"
              text={t`Update your data`}
              link={true}
              onClick={this.syncData}
              iconLeft={SyncIcon}
            />
          </ButtonGroup>
        ) : (
          <br />
        )}

        {this.getGridLayout(
          <p className="text-gray">{t`Integration`}:</p>,
          <p className="text-gray">{!serviceProvider ? t`NONE` : integration}</p>,
        )}

        {serviceProvider === ServiceProvider.HEALTH_CONNECT &&
          hasFeatureFlag(userCompanies, 'explainDataSync') &&
          this.state.healthConnectSyncedTypes.length > 0 && (
            <div style={{ marginTop: '8px', marginBottom: '8px' }}>
              <p className="text-gray" style={{ fontWeight: 500, marginBottom: '4px' }}>
                {t`Synced data and why we need it`}:
              </p>
              <ul className="text-gray" style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                {this.state.healthConnectSyncedTypes.map((type) => {
                  const descriptions: Record<string, string> = {
                    [t`Steps`]: t`Step challenges and progress`,
                    [t`Distance`]: t`Distance challenges and progress`,
                    [t`Calories`]: t`Calorie challenges and progress`,
                    [t`Heart rate`]: t`Intensive minutes and progress`,
                    [t`Sleep`]: t`Sleep challenges and progress`,
                    [t`Exercise`]: t`Exercise minutes challenges and progress`,
                  }
                  return (
                    <li key={type}>
                      <strong>{type}</strong> — {descriptions[type]}
                    </li>
                  )
                })}
              </ul>
            </div>
          )}

        <ButtonGroup>
          {/* Show "Open Apple Health settings" button only for Apple Health or Health Connect on mobile */}
          {isNative() &&
            serviceProvider === ServiceProvider.HEALTH_CONNECT &&
            !hasFeatureFlag(userCompanies, 'hideHealthConnectSettingsLink') && (
              <Button
                text={t`Open Health Connect settings`}
                link={true}
                onClick={this.openHealthSettings}
                iconLeft={EditIcon}
              />
            )}

          <Button
            text={t`Change integration`}
            link={true}
            onClick={this.toggleEditServiceProvider}
            iconLeft={EditIcon}
          />
        </ButtonGroup>

        <p className="text-gray text-center" style={{ fontStyle: 'italic' }}>
          {!showGenericSyncMessage &&
            ServiceProvider.GOOGLE_FIT === serviceProvider &&
            t`Google Fit syncs automatically when you open the YuMuuv app and also in background every hour.`}
          {ServiceProvider.APPLE_HEALTH === serviceProvider &&
            t`Apple Health syncs automatically when you open the YuMuuv app.`}
          {ServiceProvider.HEALTH_CONNECT === serviceProvider &&
            t`Health Connect syncs automatically when you open the YuMuuv app.`}
          {ServiceProvider.GARMIN === serviceProvider &&
            t`Garmin syncs automatically (in few minutes) after you have synced your device with Garmin Connect.`}
          {/*{t`Polar, Fitbit, and Suunto syncs automatically once an hour.`}*/}
          {showGenericSyncMessage && t`${integration} syncs automatically once an hour.`}
        </p>
      </section>
    )
  }

  setGender = (event: any, gender: any) => this.setState({ gender })

  setUnits = (event: any, units: any) => this.setState({ units })

  //setNewsletterSubscriber = (event: any, newsletterSubscriber: any) => this.setState({ newsletterSubscriber })

  getProfileBlock = () => {
    const { userCompanies } = this.props
    const {
      editProfile,
      email,
      dateOfBirth,
      gender,
      units,
      height,
      heightFt,
      heightIn,
      weight,
      weightLbs,
      lastName,
      firstName,
      isProfileFormValid,
      phone,
      ssn,
      timeZone,
      //newsletterSubscriber,
      hasActivityIndexData,
    } = this.state
    const showPhoneField = hasFeatureFlag(userCompanies, 'phoneField')
    const showSsnField = hasFeatureFlag(userCompanies, 'ssnField')
    const requirePhoneField = hasFeatureFlag(userCompanies, 'phoneRequired')
    const requireSsnField = hasFeatureFlag(userCompanies, 'ssnRequired')
    const ssnLastFour = hasFeatureFlag(userCompanies, 'ssnLastFour')
    const dateOfBirthFormatted = dateOfBirth
      ? getShortDateString(dayjs(dateOfBirth.trim(), DATE_FORMAT, true).locale('en').valueOf(), true)
      : ''
    // This keeps SSN rules and help text aligned with feature flags.
    const ssnHelperText = ssnLastFour ? t`Enter the last 4 digits.` : undefined
    const isSsnInvalid =
      requireSsnField && showSsnField
        ? ssnLastFour
          ? !/^\d{4}$/.test(ssn || '') && !isProfileFormValid
          : isTextFieldErrorVisible(ssn, isProfileFormValid)
        : false
    const isPhoneInvalid =
      requirePhoneField && isTextFieldErrorVisible(phone?.replace('+', '').trim() || '', isProfileFormValid)

    const ssnLastFourFormatted = ssn ? ssn.slice(-4) : ''

    return (
      <section className="settings__section">
        {!hasActivityIndexData && !hasFeatureFlag(userCompanies, 'hideSettingsActivityIndexCTA') ? (
          <div className="activity-index-info" style={{ marginTop: 0, marginBottom: 18 }}>
            <span>
              {currentLang === Lang.EN || currentLang === Lang.ET
                ? t`If you want to know what your YuMuuv activity level is, you have to provide additional data.`
                : t`If you want to know what your YuMuuv activity level is, you have to provide additional data and connect a heart rate activity device.`}
            </span>
            {` `}
            <a href={undefined} onClick={this.props.setOnboardingStatusToActivityData}>{t`Start setup`}</a>
          </div>
        ) : (
          ''
        )}
        {editProfile ? (
          <div className="settings__form">
            <Grid container spacing={3} style={{ marginBottom: 18 }}>
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <TextField
                  variant="filled"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  value={firstName || ''}
                  label={t`First name`}
                  fullWidth={true}
                  type="text"
                  name="firstName"
                  required={true}
                  error={isTextFieldErrorVisible(firstName, isProfileFormValid)}
                  style={{
                    marginBottom: 0,
                  }}
                  onChange={this.handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <TextField
                  variant="filled"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  value={lastName || ''}
                  label={t`Last name`}
                  fullWidth={true}
                  type="text"
                  name="lastName"
                  required={true}
                  error={isTextFieldErrorVisible(lastName, isProfileFormValid)}
                  style={{
                    marginBottom: 0,
                  }}
                  onChange={this.handleInputChange}
                />
              </Grid>
            </Grid>

            {/* Optional phone and SSN fields controlled by feature flags */}
            {showSsnField && (
              <div style={{ marginBottom: '16px' }}>
                <YumInput
                  label={ssnLastFour ? t`Last 4 digits of your SSN` : t`Social security number`}
                  type="text"
                  name="ssn"
                  value={ssn || ''}
                  required={requireSsnField}
                  //helperText={!isSsnInvalid ? ssnHelperText : undefined}
                  error={isSsnInvalid}
                  inputProps={ssnLastFour ? { inputMode: 'numeric', maxLength: 4 } : undefined}
                  onChange={this.handleInputChange}
                  style={{ marginBottom: 0 }}
                />
                {isSsnInvalid && (
                  <ErrorMessage>
                    {ssnLastFour
                      ? t`Enter the last 4 digits of your social security number.`
                      : t`Enter your social security number.`}
                  </ErrorMessage>
                )}
              </div>
            )}
            {showPhoneField && (
              <div style={{ marginBottom: '16px' }}>
                <YumPhoneInput
                  label={t`Phone number`}
                  name="phone"
                  value={phone || ''}
                  onChange={this.handleInputChange}
                  required={requirePhoneField}
                  error={isPhoneInvalid}
                  style={{ marginBottom: 0 }}
                />
                {isPhoneInvalid && <ErrorMessage>{t`Enter your phone number.`}</ErrorMessage>}
              </div>
            )}

            {hasActivityIndexData && (
              <>
                <FormGroup row={true}>
                  <FormControl component="fieldset" style={{ margin: '0 10px 16px 10px' }}>
                    <FormLabel component="legend" style={{ fontSize: 12 }}>{t`Sex`}</FormLabel>
                    <RadioGroup row={true} name="gender" onChange={this.setGender} value={gender || Gender.MALE}>
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Gender.MALE}
                        label={t`Male`}
                      />
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Gender.FEMALE}
                        label={t`Female`}
                      />
                    </RadioGroup>
                  </FormControl>
                </FormGroup>

                <YumDateOfBirth
                  //startIcon={DateActiveIcon}
                  label={t`Date of birth`}
                  //helperText={t`Format: DD.MM.YYYY`}
                  required={true}
                  error={isDateOfBirthErrorVisible(dateOfBirth, isProfileFormValid)}
                  value={dateOfBirth}
                  onChange={this.handleDOBChange}
                  style={{ marginBottom: '1.5rem' }}
                />

                {units === Units.METRIC && (
                  <Grid container spacing={3} style={{ marginBottom: 8 }}>
                    <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                      <YumInput
                        /*startIcon={WeightActiveIcon}
                        startIconInactive={WeightInactiveIcon}*/
                        startIcon={WeightInactiveIcon}
                        label={t`Weight`}
                        type="text"
                        inputProps={{ inputMode: 'numeric', min: MIN_WEIGHT_KG }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{unitsCountMassKilogramShort}</InputAdornment>,
                        }}
                        name="weight"
                        value={weight || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(weight, isProfileFormValid, MIN_WEIGHT_KG)}
                        onChange={this.handleInputChange}
                        style={{ marginBottom: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <YumInput
                        /*startIcon={HeightActiveIcon}
                        startIconInactive={HeightInactiveIcon}*/
                        startIcon={HeightInactiveIcon}
                        label={t`Height`}
                        value={height || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                        type="text"
                        inputProps={{ inputMode: 'numeric', min: MIN_HEIGHT_CM }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                        }}
                        name="height"
                        onChange={this.handleInputChange}
                        style={{ marginBottom: 0 }}
                      />
                    </Grid>
                  </Grid>
                )}

                {units === Units.IMPERIAL && (
                  <Grid container spacing={3} style={{ marginBottom: 8 }}>
                    <Grid item xs={12} sm={5} style={{ paddingBottom: 0 }}>
                      <YumInput
                        /*startIcon={WeightActiveIcon}
                        startIconInactive={WeightInactiveIcon}*/
                        startIcon={WeightInactiveIcon}
                        label={t`Weight`}
                        type="text"
                        inputProps={{ inputMode: 'numeric' }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{unitsCountMassPoundShort}</InputAdornment>,
                        }}
                        name="weightLbs"
                        value={weightLbs || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(weight, isProfileFormValid, MIN_WEIGHT_KG)}
                        style={{
                          marginBottom: 0,
                        }}
                        onChange={this.handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <YumSelect
                            label={t`Height`}
                            startIcon={HeightInactiveIcon}
                            value={heightFt}
                            onChange={this.handleHeightFtChange}
                            error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                            style={{ marginBottom: 0 }}
                          >
                            {[...Array(7)].map((e, i) => {
                              i += 3
                              return (
                                <option key={i} value={i}>
                                  {i} {unitsCountLengthFootShort}
                                </option>
                              )
                            })}
                          </YumSelect>
                        </Grid>
                        <Grid item xs={6}>
                          <YumSelect
                            label={t`Height`}
                            value={heightIn}
                            onChange={this.handleHeightInChange}
                            error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                            style={{ marginBottom: 0 }}
                          >
                            {[...Array(12)].map((e, i) => {
                              return (
                                <option key={i} value={i}>
                                  {i} {unitsCountLengthInchShort}
                                </option>
                              )
                            })}
                          </YumSelect>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            )}

            <FormGroup row={true} className="">
              <FormControl component="fieldset" style={{ margin: '0 10px 16px 10px' }}>
                <FormLabel component="legend" style={{ fontSize: 12 }}>{t`Units of measure`}</FormLabel>
                <RadioGroup row aria-label="units" name="units" onChange={this.setUnits} value={units || Units.METRIC}>
                  <FormControlLabel
                    control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                    value={Units.METRIC}
                    label={t`Metric`}
                  />
                  <FormControlLabel
                    control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                    value={Units.IMPERIAL}
                    label={t`Imperial`}
                  />
                </RadioGroup>
              </FormControl>
            </FormGroup>

            <FormControl style={{ display: 'block' }}>
              <InputLabel htmlFor="timeZone" required={true}>{t`Time zone`}</InputLabel>
              <YumTimeZoneSelect value={timeZone} onChange={this.handleTimeZoneChange} required={true} />
            </FormControl>

            {/*<FormGroup row={true} style={{ marginTop: '18px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="newsletterSubscriber"
                    checked={newsletterSubscriber}
                    onChange={this.setNewsletterSubscriber}
                  />
                }
                label={t`Subscribe to newsletter`}
              />
            </FormGroup>*/}
          </div>
        ) : (
          <>
            <div className="text-right">
              <p>
                <span className="text-gray pull-left">{t`Email`}:</span>
                {email}
              </p>
              <p>
                <span className="text-gray pull-left">{t`First name`}:</span>
                {firstName}
              </p>
              <p>
                <span className="text-gray pull-left">{t`Last name`}:</span>
                {lastName}
              </p>
              {showSsnField && (
                <p>
                  <span className="text-gray pull-left">{t`Social security number`}:</span>
                  &nbsp;{ssnLastFourFormatted ? '***-**-' + ssnLastFourFormatted : ''}
                </p>
              )}
              {showPhoneField && (
                <p>
                  <span className="text-gray pull-left">{t`Phone number`}:</span>
                  &nbsp;{phone || ''}
                </p>
              )}
              {hasActivityIndexData && (
                <>
                  <p>
                    <span className="text-gray pull-left">{t`Sex`}:</span>
                    {gender === Gender.FEMALE ? t`Female` : t`Male`}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Date of birth`}:</span>
                    &nbsp;{dateOfBirthFormatted}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Weight`}:</span>
                    {Units.IMPERIAL === units && weightLbs
                      ? `${precisionRoundMod(parseFloat(weightLbs), 5)} ${unitsCountMassPoundShort}`
                      : `${weight} ${unitsCountMassKilogramShort}`}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Height`}:</span>
                    {Units.IMPERIAL === units && heightFt
                      ? `${heightFt} ${unitsCountLengthFootShort} ${heightIn || '0'} ${unitsCountLengthInchShort}`
                      : `${height} ${unitsCountLengthCentimeterShort}`}
                  </p>
                </>
              )}
              {units && (
                <p>
                  <span className="text-gray pull-left">{t`Units of measure`}:</span>
                  &nbsp;{units == Units.IMPERIAL ? t`Imperial` : t`Metric`}
                </p>
              )}
              <p>
                <span className="text-gray pull-left">{t`Time zone`}:</span>
                &nbsp;{timeZone}
              </p>
              {/*<p>
                <span className="text-gray pull-left">{t`Subscribe to newsletter`}:</span>
                &nbsp;{newsletterSubscriber ? t`Yes` : t`No`}
              </p>*/}
            </div>
          </>
        )}

        {/*<ButtonGroup>
          {editProfile && <Button text={t`Save`} link={false} onClick={this.editProfile} />}
          <Button
            text={editProfile ? t`Cancel` : t`Edit profile`}
            link={true}
            onClick={this.cancelEditProfile}
            iconLeft={!editProfile ? EditIcon : undefined}
          />
        </ButtonGroup>*/}

        <Grid container spacing={3} style={{ marginBottom: 18 }}>
          <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
            {editProfile && (
              <YumButtonGroup style={{ marginTop: '1rem' }}>
                <YumCancelButton onClick={this.cancelEditProfile} />
                <YumSubmitButton text={t`Save`} onClick={this.editProfile} />
              </YumButtonGroup>
            )}
            {!editProfile && (
              <Button
                text={t`Edit profile`}
                link={true}
                onClick={this.cancelEditProfile}
                iconLeft={!editProfile ? EditIcon : undefined}
              />
            )}
          </Grid>
        </Grid>
      </section>
    )
  }

  handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = target
    this.setState({ [name]: value } as any)

    if ('weight' === name) {
      let weightLbs = convert(value).from('kg').to('lb')
      weightLbs = precisionRoundMod(weightLbs, 5)
      this.setState({ weightLbs })
    }

    if ('weightLbs' === name) {
      let weight = convert(value).from('lb').to('kg')
      weight = precisionRoundMod(weight, 5)
      this.setState({ weight })
    }

    if ('height' === name) {
      const { heightFt, heightIn } = convertCmToFtIn(value)
      this.setState({ heightFt, heightIn })
    }
  }

  handleHeightFtChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(value, parseInt(this.state.heightIn))
    this.setState({ heightFt: value, height })
  }

  handleHeightInChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(parseInt(this.state.heightFt), value)
    this.setState({ heightIn: value, height })
  }

  handleDOBChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ dateOfBirth: event.target.value }, () =>
      this.setState({ isProfileFormValid: this.isProfileFormValid() }),
    )
  }

  handleTimeZoneChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ timeZone: event.target.value as string })
  }

  handleFocus = (name: string) => {
    // @ts-ignore
    this.setState({ focus: { ...this.state.focus, [name]: true } })
  }

  handleBlur = (name: string) => {
    // @ts-ignore
    this.setState({ focus: { ...this.state.focus, [name]: false } })
  }

  onPolicyChange = (isPasswordPolicyValid: boolean) => {
    this.setState({ isPasswordPolicyValid })
  }

  getChangePasswordForm = () => {
    const { editPassword } = this.state
    const passwordPolicy =
      (this.props.userCompanies.find((uc: UserCompanyDto) => uc.passwordPolicy)?.passwordPolicy as PasswordPolicy) ||
      PasswordPolicy.DEFAULT
    const passwordMinimumLength =
      this.props.userCompanies
        .filter((uc) => uc.passwordMinLength)
        .sort((a, b) => b.passwordMinLength - a.passwordMinLength)[0]?.passwordMinLength || 6
    const newPasswordError = this.state.newPassword.length < passwordMinimumLength
    return (
      <section className="settings__section">
        <Grid container={true}>
          <Grid item={true} xs={12} sm={6} md={4}>
            {editPassword ? (
              <>
                <YumInput
                  startIcon={LockFilledIcon}
                  startIconInactive={LockIcon}
                  label={t`Old password`}
                  type="password"
                  name="oldPassword"
                  onChange={this.handleInputChange}
                  value={this.state.oldPassword}
                />
                <YumInput
                  startIcon={newPasswordError && !this.state.focus.newPassword ? LockErrorIcon : LockFilledIcon}
                  startIconInactive={LockIcon}
                  label={t`New password`}
                  type="password"
                  name="newPassword"
                  onChange={this.handleInputChange}
                  value={this.state.newPassword}
                  error={newPasswordError && !!this.state.newPassword && !this.state.focus.newPassword}
                  onFocus={() => this.handleFocus('newPassword')}
                  onBlur={() => this.handleBlur('newPassword')}
                  InputProps={{
                    /*startAdornment: (
                      <InputAdornment position="start">
                        {newPasswordError && !this.state.focus.newPassword ? (
                          <LockErrorIcon />
                        ) : !!this.state.newPassword || this.state.focus.newPassword ? (
                          <LockFilledIcon />
                        ) : (
                          <LockIcon />
                        )}
                      </InputAdornment>
                    ),*/
                    endAdornment:
                      newPasswordError && !!this.state.newPassword ? (
                        <InputAdornment position="end">
                          <Tooltip
                            title={t`Password must be at least 6 characters`.replace(
                              '6',
                              String(passwordMinimumLength),
                            )}
                            placement="top-end"
                            open={!!this.state.newPassword && !this.state.focus.newPassword}
                            arrow
                          >
                            <ErrorIcon />
                          </Tooltip>
                        </InputAdornment>
                      ) : (
                        ''
                      ),
                  }}
                />
                {passwordPolicy !== PasswordPolicy.DEFAULT && (
                  <>
                    <YumPasswordPolicy
                      policy={passwordPolicy}
                      password={this.state.newPassword}
                      onPolicyChange={this.onPolicyChange}
                    />
                  </>
                )}
                <YumInput
                  startIcon={
                    this.state.newPassword !== this.state.confirmPassword && !this.state.focus.confirmPassword
                      ? LockErrorIcon
                      : LockFilledIcon
                  }
                  startIconInactive={LockIcon}
                  label={t`Confirm password`}
                  type="password"
                  name="confirmPassword"
                  onChange={this.handleInputChange}
                  value={this.state.confirmPassword}
                  style={{ marginBottom: 0 }}
                  onFocus={() => this.handleFocus('confirmPassword')}
                  onBlur={() => this.handleBlur('confirmPassword')}
                  error={this.state.newPassword !== this.state.confirmPassword && !this.state.focus.confirmPassword}
                  InputProps={{
                    endAdornment:
                      this.state.newPassword !== this.state.confirmPassword ? (
                        <InputAdornment position="end">
                          <Tooltip
                            title={t`Confirmation password does not match new password`}
                            placement="top-end"
                            open={!!this.state.confirmPassword && !this.state.focus.confirmPassword}
                            arrow
                          >
                            <ErrorIcon />
                          </Tooltip>
                        </InputAdornment>
                      ) : this.state.confirmPassword ? (
                        <InputAdornment position="end">
                          <AcceptedIcon />
                        </InputAdornment>
                      ) : (
                        ''
                      ),
                  }}
                />
              </>
            ) : (
              ''
            )}

            {/*<ButtonGroup>
              {editPassword && (
                <Button text={t`Save`} link={false} onClick={!newPasswordError ? this.changePassword : () => {}} />
              )}
              <Button
                text={editPassword ? t`Cancel` : t`Change password`}
                link={true}
                onClick={this.cancelEditPassword}
                iconLeft={!editPassword ? EditIcon : undefined}
              />
            </ButtonGroup>*/}

            {editPassword && (
              <YumButtonGroup style={{ marginTop: '1rem' }}>
                <YumCancelButton onClick={this.cancelEditPassword} />
                <YumSubmitButton text={t`Save`} onClick={!newPasswordError ? this.changePassword : () => {}} />
              </YumButtonGroup>
            )}
            {!editPassword && (
              <Button text={t`Change password`} link={true} onClick={this.cancelEditPassword} iconLeft={EditIcon} />
            )}
          </Grid>
        </Grid>
      </section>
    )
  }

  openDeleteModal = () => this.setState({ isDeleteModalOpen: true })
  closeDeleteModal = () => this.setState({ isDeleteModalOpen: false })

  getDeleteModal = () => (
    <>
      <Button
        text={t`Delete account`}
        link={true}
        onClick={this.openDeleteModal}
        iconLeft={DeleteIcon}
        className="btn-delete-account"
      />
      <YumDialog open={this.state.isDeleteModalOpen}>
        <YumDialogTitle>{t`Delete account`}</YumDialogTitle>
        <YumDialogContent>
          <YumDialogContentText>{t`Are you sure you want to delete your account?`}</YumDialogContentText>
        </YumDialogContent>
        <YumDialogActions>
          <YumCancelButton onClick={this.closeDeleteModal} submitInProgress={this.state.deleteInProgress} />
          <YumSubmitButton
            text={t`Delete`}
            onClick={this.deleteUser}
            submitInProgress={this.state.deleteInProgress}
            color="error"
          />
        </YumDialogActions>
      </YumDialog>
    </>
  )

  render() {
    const { hasRole, userDto, changeUserLanguage } = this.props
    const { firstName, lastName, email, passwordSet } = userDto
    const fullName = getFullName(firstName, lastName, email)
    const supportEmail = currentLang === Lang.ET ? 'tugi@yumuuv.com' : 'support@yumuuv.com'

    return (
      <div className="settings">
        <Card>
          <NotificationsWrapper />

          <h1>{t`Your details`}</h1>

          {hasRole(Role.USER) && (
            <>
              <Initials className="settings__initials" fullName={fullName} size={'xl'} inline={false} />
              {this.getIntegrationBlock()}
              {this.getProfileBlock()}
              {/*{this.getAchievementBlock()}*/}
            </>
          )}

          <section className="settings__section">
            {this.getGridLayout(
              <p className="text-gray" style={{ lineHeight: '26px' }}>
                {t`Language selection`}:
              </p>,
              <div>
                {/*<LanguageSelection onSubmit={changeUserLanguage} currentLang={getLocale()} />*/}
                <YumLanguageSelection onSubmit={changeUserLanguage} />
              </div>,
            )}
          </section>

          {(passwordSet || hasRole(Role.ADMIN)) && this.getChangePasswordForm()}

          {/*{hasRole(Role.USER) && this.getCompaniesBlock()}*/}
          <CompaniesWrapper />

          <section className="settings__section settings__section--buttons-section">
            <ButtonGroup>
              <Button
                text={supportEmail}
                link={true}
                blue={true}
                externalLink={true}
                iconLeft={EmailIcon}
                url={`mailto:${supportEmail}`}
              />

              <Button
                text={t`Privacy Policy`}
                link={true}
                blue={true}
                iconLeft={PrivacyIcon}
                onClick={openPrivacyPolicy}
              />

              <Button
                text={t`Terms of Service`}
                link={true}
                blue={true}
                iconLeft={PrivacyIcon}
                onClick={openTermsOfService}
              />

              {this.getDeleteModal()}
            </ButtonGroup>
          </section>
        </Card>
      </div>
    )
  }
}
